module.exports = __webpack_public_path__ + "static/media/cauldron.eddfb733.svg";